// Customizable Area Start
import React, { Component } from "react"
import { Avatar, Box, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"
import { Swiper, SwiperSlide } from "swiper/react"
import { FreeMode } from "swiper/modules"
import "swiper/css"
import "swiper/css/free-mode"
import CustomEmptyResultInfo from "./CustomEmptyResultInfo.web"
const configJSON = require("./config.js")

const ARTISTS_SLIDER_BREAKPOINTS = {
  320: { slidesPerView: 1.3, spaceBetween: 10 },
  550: { slidesPerView: 2.3, spaceBetween: 10 },
  900: { slidesPerView: 3, spaceBetween: 15 },
  1124: { slidesPerView: 4, spaceBetween: 15 },
  1280: { slidesPerView: 5, spaceBetween: 15 },
}

const ArtistContentWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  maxWidth: "280px",
})

const ArtistImageWrapper = styled(Box)({
  width: "100%",
  height: "325px",
  borderRadius: "12px",
  overflow: "hidden",
  display: "flex",
  justifyContent: "center",
  transition: "transform 0.4s ease",
})

const ArtistImage = styled(Avatar)({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  borderRadius: "12px",
  transition: "transform 0.4s ease",
})

const ArtistName = styled(Typography)({
  width: "100%",
  color: "#000",
  fontSize: "1.375rem",
  fontWeight: 600,
  marginTop: "10px",
  textAlign: "left",
})

const ArtistRole = styled(Typography)({
  width: "100%",
  color: "#64748b",
  fontSize: "1.125rem",
  fontWeight: 400,
  marginTop: "5px",
})

const CustomSlide = styled(SwiperSlide)({
  display: "flex",
  justifyContent: "center",
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  cursor: "pointer",
 "@media (hover: hover) and (pointer: fine)": {
  "&:hover .artist-image": {
    transform: "scale(1.05)",
  },
}
})

interface Artist {
  id: string
  image: string
  name: string
  role: string
}

interface Props {
  trendingArtists: Artist[]
  handleUserProfileRedirection: (user: Artist) => void
}

export class LandingArtistCarousel extends Component<Props> {
  render() {
    const { trendingArtists, handleUserProfileRedirection } = this.props
    return (
      <CustomEmptyResultInfo
        resultsLength={trendingArtists.length}
        message={configJSON.emptyArtistsMessage}
      >
        <Swiper
          freeMode
          grabCursor
          slidesPerView={5}
          spaceBetween={15}
          modules={[FreeMode]}
          breakpoints={ARTISTS_SLIDER_BREAKPOINTS}
        >
          {trendingArtists.map((artistInfo: Artist) => {
            const { id, image, name, role } = artistInfo
            return (
              <CustomSlide
                key={String(id)}
                data-test-id="artist-slide"
                onClick={() => handleUserProfileRedirection(artistInfo)}
              >
                <ArtistContentWrapper>
                  <ArtistImageWrapper>
                    <ArtistImage src={image} className="artist-image" />
                  </ArtistImageWrapper>
                  <ArtistName>{name}</ArtistName>
                  <ArtistRole>{role}</ArtistRole>
                </ArtistContentWrapper>
              </CustomSlide>
            )
          })}
        </Swiper>
      </CustomEmptyResultInfo>
    )
  }
}

export default LandingArtistCarousel
// Customizable Area End
